import React, { PropTypes } from "react";
import AcquireWebComponent from "../../framework/MaterialUI";
import FileFileDownload from "material-ui/svg-icons/file/file-download";
import { splitNumber } from "../../../utils/utility";

import moment from "moment";
import isEmpty from "lodash/isEmpty";
import isUndefined from "lodash/isUndefined";
import map from "lodash/map";
import find from "lodash/find";
import "./audience_files.css";

class AudienceFilesDownload extends AcquireWebComponent {
  constructor(props) {
    super(props);
    this.state = { collapsed: false, downloadFileId: undefined };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.blobData && isUndefined(this.props.blobData)) {
      var FileSaver = require("file-saver");
      if (this.props.datas && this.props.datas.length > 0) {
        const data = find(this.props.datas, data => {
          return data.id === this.state.downloadFileId;
        });
        if (data) {
          const { fileName } = data;
          const arrs = fileName.split("/");
          FileSaver.saveAs(
            nextProps.blobData,
            arrs[arrs.length - 1].replace(".gz", ".zip"),
          );
        }
      }
    }
  }

  downloadFile(e, id) {
    e.preventDefault();
    this.setState({ downloadFileId: id });
    this.props.downloadFile(id);
  }

  render() {
    const { datas } = this.props;
    if (!datas) {
      return (
        <div className="light-grey-border bg-white p-20 af-summary-container">
          Loading...
        </div>
      );
    }
    if (isEmpty(datas)) {
      return <div />;
    }

    return (
      <div className="light-grey-border bg-white p-20 af-summary-container">
        <div className="aa-title">DOWNLOAD AUDIENCE FILES</div>
        <div className="pt-10">
          Files will be kept on the system for 30 days after which time they
          will be removed
        </div>
        <div className="light-grey-border-top light-grey-border-bottom mt-20 list-sub-title ">
          <span
            style={{
              width: "40%",
              display: "inline-block",
              paddingLeft: "10px",
            }}
          >
            File(s)
          </span>
          <span
            style={{
              width: "30%",
              display: "inline-block",
              paddingLeft: "20px",
            }}
          >
            File Creation Date
          </span>
          <span
            style={{
              display: "inline-block",
              textAlign: "right",
              width: "30%",
              paddingRight: "20px",
            }}
          >
            Download Audience File
          </span>
        </div>
        {map(datas, data => {
          const { id, startDatetime, consumerRecords, businessRecords } = data;
          const dt = moment.unix(startDatetime / 1000).format("M/D/YY");
          return (
            <div key={"audience-file-section-" + id}>
              <div
                key={"audience-file-item-" + id}
                className="light-grey-border-bottom list-item "
                style={{ position: "relative", paddingLeft: "20px" }}
              >
                <span
                  className="download-files-table-col"
                  onClick={e => {
                    e.preventDefault();
                    this.setState({
                      [`collapsed${id}`]: !this.state[`collapsed${id}`],
                    });
                  }}
                >
                  <div
                    className={
                      this.state[`collapsed${id}`]
                        ? "arrow-right"
                        : "arrow-down"
                    }
                  />
                  Consumer and Business Files
                </span>
                <span
                  style={{
                    width: "30%",
                    display: "inline-block",
                    paddingLeft: "20px",
                  }}
                >
                  {dt}
                </span>
                <span
                  style={{
                    width: "30%",
                    display: "inline-block",
                    textAlign: "right",
                    height: "13px",
                    paddingRight: "10px",
                  }}
                >
                  <a
                    onClick={e => {
                      this.downloadFile(e, id);
                    }}
                    download="aa.zip"
                  >
                    <FileFileDownload
                      style={{ height: "20px", width: "20px", float: "right" }}
                    />
                  </a>
                </span>
              </div>
              <div
                className={
                  this.state[`collapsed${id}`] ? "panel-collapse collapse" : ""
                }
              >
                <div
                  key={"audience-file-item-consumer-" + id}
                  className="light-grey-border-bottom list-item ml-20 pl-10 no-padding-left "
                >
                  Consumer Records -{" "}
                  {isUndefined(consumerRecords)
                    ? "0"
                    : splitNumber(consumerRecords)()}{" "}
                  Records
                </div>
                <div
                  key={"audience-file-item-business-" + id}
                  className="light-grey-border-bottom list-item ml-20 pl-10 "
                >
                  Business Records -{" "}
                  {isUndefined(businessRecords)
                    ? "0"
                    : splitNumber(businessRecords)()}{" "}
                  Records
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default AudienceFilesDownload;

AudienceFilesDownload.propTypes = {
  datas: PropTypes.array,
  downloadFile: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Insights/audienceFiles/AudienceFilesDownload.jsx